// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family:
    'Inter',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    'Helvetica Neue',
    Arial,
    'Noto Sans',
    sans-serif,
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol',
    'Noto Color Emoji';
  margin: 0;
  height: 100%;
  background-color: #f0f2f5;
  color: rgba(0, 0, 0, 0.85);
}

html {
  height: 100%;
}

#root {
  height: 100%;
}

/* Remove legacy login container styles that are now replaced with AntD components */
.login-container,
.login-card,
.login-title,
.login-subtitle,
.login-loading,
.login-error {
  /* These classes are no longer used */
}

/* Add consistent card styling */
.ant-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* Add consistent typography */
.ant-typography {
  color: rgba(0, 0, 0, 0.85);
}

h1.ant-typography,
h2.ant-typography,
h3.ant-typography,
h4.ant-typography {
  font-weight: 600;
}

/* Consistent form styles */
.ant-form-item-label > label {
  font-weight: 500;
}

/* Add a bit of padding to table cells for better readability */
.ant-table-cell {
  padding: 12px 16px !important;
}

/* Consistent button styles */
.ant-btn {
  border-radius: 4px;
}

/* Add container max-width (this is a fallback, we're primarily using the inline style) */
.content-container {
  width: 100%;
  margin: 0 auto;
}

/* Stats Table Styling */
.stats-table-wrapper {
  width: 100%;
  overflow-x: auto;
  position: relative;
  border-radius: 8px;
  margin-bottom: 16px;
}

/* Style for the table headers (date columns and Показатель) */
.stats-table-wrapper .ant-table-thead > tr > th {
  background-color: #6aa84f !important;
  color: white !important;
  font-weight: 500;
  border-bottom: 1px solid #59913f;
}

/* Hover effect for header cells */
.stats-table-wrapper .ant-table-thead > tr > th:hover {
  background-color: #7db65f !important;
}

/* Make the header sticky when scrolling */
.stats-table-wrapper .ant-table-header {
  background-color: #6aa84f;
}

/* Style for the fixed metric column */
.metric-column {
  background-color: #fafafa;
  font-weight: 500;
  border-right: 1px solid #f0f0f0;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.03);
  z-index: 1;
}

/* Style for other fixed columns */
.fixed-column {
  background-color: #fafafa;
  border-right: 1px solid #f0f0f0;
  z-index: 1;
}

/* Style for the Факт column with aggregated data */
.fact-column,
.ant-table-cell.fact-column {
  background-color: #f5f9ff !important;
  font-weight: 600;
}

/* Ensure fact column styling applies to both header and body cells */
.ant-table-cell[class*='fact-column'],
td.ant-table-cell-fix-left[data-colindex='2'] {
  background-color: #f5f9ff !important;
  font-weight: 600;
}

/* Make sure the Факт column header has the green background */
.ant-table-thead .ant-table-cell.fact-column {
  background-color: #6aa84f !important;
  color: white !important;
  font-weight: 500;
}

/* Style for table cell fact values (not headers) */
.ant-table-tbody .ant-table-cell.fact-column,
td.ant-table-cell-fix-left[data-colindex='2'] {
  background-color: #f5f9ff !important;
  font-weight: 600;
}

/* Add a divider line after the fixed columns group */
.ant-table-cell.ant-table-cell-fix-left:nth-child(4) {
  border-right: 2px solid #d9d9d9;
  box-shadow: 3px 0 6px rgba(0, 0, 0, 0.05);
}

/* Ensure the fixed column has consistent styling */
.ant-table-cell.ant-table-cell-fix-left {
  background-color: #fafafa;
  z-index: 2;
}

/* Fixed header cell should match the green color and have higher z-index */
.ant-table-cell.ant-table-cell-fix-left.ant-table-cell-fix-top,
.ant-table-cell.ant-table-cell-fix-top {
  background-color: #6aa84f !important;
  color: white !important;
  z-index: 3;
}

/* Style for table titles */
.stats-table-wrapper .ant-table-title {
  padding: 12px 16px;
  background-color: #f8f8f8;
  border-bottom: 1px solid #eee;
  border-radius: 8px 8px 0 0;
}

/* Add a subtle shadow to emphasize the header */
.daily-stats-table .ant-table-thead > tr,
.monthly-stats-table .ant-table-thead > tr {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Add scrollbar styling for better visibility */
.stats-table-wrapper::-webkit-scrollbar {
  height: 8px;
}

.stats-table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.stats-table-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.stats-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE;;;;;;;;;;;;;sBAaoB;EACpB,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,oFAAoF;AACpF;;;;;;EAME,qCAAqC;AACvC;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE,0BAA0B;AAC5B;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA,yFAAyF;AACzF;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;AACtC;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;EAC/B,yCAAyC;EACzC,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,UAAU;AACZ;;AAEA,mDAAmD;AACnD;;EAEE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;;EAEE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;;EAEE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA,mDAAmD;AACnD;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA,2EAA2E;AAC3E;;EAEE,oCAAoC;EACpC,uBAAuB;EACvB,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;;EAEE,yCAAyC;AAC3C;;AAEA,gDAAgD;AAChD;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["body {\n  font-family:\n    'Inter',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    Roboto,\n    'Helvetica Neue',\n    Arial,\n    'Noto Sans',\n    sans-serif,\n    'Apple Color Emoji',\n    'Segoe UI Emoji',\n    'Segoe UI Symbol',\n    'Noto Color Emoji';\n  margin: 0;\n  height: 100%;\n  background-color: #f0f2f5;\n  color: rgba(0, 0, 0, 0.85);\n}\n\nhtml {\n  height: 100%;\n}\n\n#root {\n  height: 100%;\n}\n\n/* Remove legacy login container styles that are now replaced with AntD components */\n.login-container,\n.login-card,\n.login-title,\n.login-subtitle,\n.login-loading,\n.login-error {\n  /* These classes are no longer used */\n}\n\n/* Add consistent card styling */\n.ant-card {\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n/* Add consistent typography */\n.ant-typography {\n  color: rgba(0, 0, 0, 0.85);\n}\n\nh1.ant-typography,\nh2.ant-typography,\nh3.ant-typography,\nh4.ant-typography {\n  font-weight: 600;\n}\n\n/* Consistent form styles */\n.ant-form-item-label > label {\n  font-weight: 500;\n}\n\n/* Add a bit of padding to table cells for better readability */\n.ant-table-cell {\n  padding: 12px 16px !important;\n}\n\n/* Consistent button styles */\n.ant-btn {\n  border-radius: 4px;\n}\n\n/* Add container max-width (this is a fallback, we're primarily using the inline style) */\n.content-container {\n  width: 100%;\n  margin: 0 auto;\n}\n\n/* Stats Table Styling */\n.stats-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  position: relative;\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n/* Style for the table headers (date columns and Показатель) */\n.stats-table-wrapper .ant-table-thead > tr > th {\n  background-color: #6aa84f !important;\n  color: white !important;\n  font-weight: 500;\n  border-bottom: 1px solid #59913f;\n}\n\n/* Hover effect for header cells */\n.stats-table-wrapper .ant-table-thead > tr > th:hover {\n  background-color: #7db65f !important;\n}\n\n/* Make the header sticky when scrolling */\n.stats-table-wrapper .ant-table-header {\n  background-color: #6aa84f;\n}\n\n/* Style for the fixed metric column */\n.metric-column {\n  background-color: #fafafa;\n  font-weight: 500;\n  border-right: 1px solid #f0f0f0;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.03);\n  z-index: 1;\n}\n\n/* Style for other fixed columns */\n.fixed-column {\n  background-color: #fafafa;\n  border-right: 1px solid #f0f0f0;\n  z-index: 1;\n}\n\n/* Style for the Факт column with aggregated data */\n.fact-column,\n.ant-table-cell.fact-column {\n  background-color: #f5f9ff !important;\n  font-weight: 600;\n}\n\n/* Ensure fact column styling applies to both header and body cells */\n.ant-table-cell[class*='fact-column'],\ntd.ant-table-cell-fix-left[data-colindex='2'] {\n  background-color: #f5f9ff !important;\n  font-weight: 600;\n}\n\n/* Make sure the Факт column header has the green background */\n.ant-table-thead .ant-table-cell.fact-column {\n  background-color: #6aa84f !important;\n  color: white !important;\n  font-weight: 500;\n}\n\n/* Style for table cell fact values (not headers) */\n.ant-table-tbody .ant-table-cell.fact-column,\ntd.ant-table-cell-fix-left[data-colindex='2'] {\n  background-color: #f5f9ff !important;\n  font-weight: 600;\n}\n\n/* Add a divider line after the fixed columns group */\n.ant-table-cell.ant-table-cell-fix-left:nth-child(4) {\n  border-right: 2px solid #d9d9d9;\n  box-shadow: 3px 0 6px rgba(0, 0, 0, 0.05);\n}\n\n/* Ensure the fixed column has consistent styling */\n.ant-table-cell.ant-table-cell-fix-left {\n  background-color: #fafafa;\n  z-index: 2;\n}\n\n/* Fixed header cell should match the green color and have higher z-index */\n.ant-table-cell.ant-table-cell-fix-left.ant-table-cell-fix-top,\n.ant-table-cell.ant-table-cell-fix-top {\n  background-color: #6aa84f !important;\n  color: white !important;\n  z-index: 3;\n}\n\n/* Style for table titles */\n.stats-table-wrapper .ant-table-title {\n  padding: 12px 16px;\n  background-color: #f8f8f8;\n  border-bottom: 1px solid #eee;\n  border-radius: 8px 8px 0 0;\n}\n\n/* Add a subtle shadow to emphasize the header */\n.daily-stats-table .ant-table-thead > tr,\n.monthly-stats-table .ant-table-thead > tr {\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n/* Add scrollbar styling for better visibility */\n.stats-table-wrapper::-webkit-scrollbar {\n  height: 8px;\n}\n\n.stats-table-wrapper::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.stats-table-wrapper::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n.stats-table-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
